// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Checkbox,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { StripeProvider, Elements } from 'react-stripe-elements';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import CardForm from './CardInjectedForm';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { getConfig } from '../../../../../config';

const StyledTitle = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const StyledInfo = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

const StyledIsSecretCheckboxWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  span {
    margin-top: 5px;
  }

  .checkbox {
    margin: 0;
    margin-right: 20px;

    input {
      width: 21px;
      height: 21px;
    }
  }
`;

const StyledPromoCodeWrapper = styled.div`
  width: 50%;
  display: flex;
  align-items: center;

  button {
    margin-left: 20px;
    margin-top: 16px;
  }
`;

const config = getConfig();
const stripeApiKey = config.stripe.publishableKey;

const EventBookablePaymentForm = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  draftActivity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedBookingOptions,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isSecret,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setIsSecret,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  verifiedCard,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setVerifiedCard,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setIsLoading,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onConfirmOrder,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  promoCode,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setPromoCode,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onPromoCodeApply,
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { subtotalPrice, totalTax, totalPrice } = draftActivity;

  const onIsSecretChange = () => {
    const newValue = !isSecret;
    setIsSecret(newValue);
  };

  return (
    <StripeProvider apiKey={stripeApiKey}>
      <div>
        <StyledTitle>Card:</StyledTitle>
        <Elements>
          <CardForm
            verifiedCard={verifiedCard}
            setVerifiedCard={setVerifiedCard}
            setIsLoading={setIsLoading}
          />
        </Elements>
        <StyledPromoCodeWrapper>
          <FormGroup controlId='promoCode'>
            <ControlLabel>Promo Code:</ControlLabel>
            <FormControl
              type='text'
              onChange={e => setPromoCode(e.target.value)}
              value={promoCode}
            />
          </FormGroup>
          <Button disabled={!promoCode} onClick={onPromoCodeApply}>
            Apply
          </Button>
        </StyledPromoCodeWrapper>
        <StyledIsSecretCheckboxWrapper>
          <Checkbox checked={isSecret} onChange={onIsSecretChange} />
          <span>Is this a secret event?</span>
        </StyledIsSecretCheckboxWrapper>
        <hr />
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {selectedBookingOptions.map(option => (
          <StyledInfo key={option.id}>
            {option.title} (${option.price})
          </StyledInfo>
        ))}
        <StyledInfo>
          Estimated Tax: ${totalTax} (
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
            // @ts-ignore
            (totalTax / subtotalPrice).toFixed(2) * 100
          }
          %)
        </StyledInfo>
        <StyledInfo style={{ fontWeight: 600 }}>
          Total Due: ${totalPrice}
        </StyledInfo>
        <Button
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          disabled={!verifiedCard || !!verifiedCard.error}
          onClick={onConfirmOrder}
        >
          Complete Your Purchase
        </Button>
      </div>
    </StripeProvider>
  );
};

export default EventBookablePaymentForm;
